export interface AppSettings {
  dir: 'ltr' | 'rtl';
  theme: string;
  sidenavOpened: boolean;
  sidenavCollapsed: boolean;
  boxed: boolean;
  horizontal: boolean;
  activeTheme: string;
  language: string;
  cardBorder: boolean;
  navPos: 'side' | 'top';
}

export const defaults: AppSettings = {
  dir: 'ltr', // side bar on left
  theme: 'moon',
  sidenavOpened: false,
  sidenavCollapsed: false,
  boxed: true, // page full width
  horizontal: true,
  cardBorder: false,
  activeTheme: 'green_theme',
  language: 'en-us',
  navPos: 'side',
};
